import React from "react";
import { Form } from "react-bootstrap";

const FormLabel = ({
  value,
  ...rest
}) => {
  return (
    <>
    <Form.Label
         style={{fontWeight : "bold"}}
         {...rest}
       >
        {value}
        </Form.Label>
     
    </>
  );
};

export default FormLabel;
